const { default: Simplebar } = require('simplebar')
angular.module('common.directives').directive('ngSimplebar', function () {
  return {
    scope: {
      ngSimplebarOptions: '=?'
    },
    link: function (scope, elem, attrs) {
      if (scope.ngSimplebarOptions.enable) {
        const simpleBar = new Simplebar(elem[0], scope.ngSimplebarOptions)
      }
    }
  }
})
